import { styled } from '@mui/material';

import { TextFieldValidator } from '/shared/TextFieldValidator';

export const AppNameStyled = styled(TextFieldValidator)`
  width: 100%;
`;
